import { shopifyListingIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const clearListingImages = {
  name: "clearListingImages" as const,
  input: z.object({ shopifyListingId: shopifyListingIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
